"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popper = void 0;
var react_1 = __importDefault(require("react"));
var usePopper_1 = require("./usePopper");
var Popper = function (_a) {
    var _b = _a.open, defaultOpen = _b === void 0 ? false : _b, anchor = _a.anchor, children = _a.children, _c = _a.distance, distance = _c === void 0 ? 8 : _c, _d = _a.placement, placement = _d === void 0 ? "bottom-start" : _d, _e = _a.onClose, onClose = _e === void 0 ? function () { } : _e, rest = __rest(_a, ["open", "anchor", "children", "distance", "placement", "onClose"]);
    var _f = (0, usePopper_1.usePopper)({
        open: defaultOpen,
        distance: distance,
        placement: placement,
        onClose: onClose,
    }), anchorRef = _f.anchorRef, childrenRef = _f.childrenRef, open = _f.open;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.cloneElement(anchor, __assign({ ref: anchorRef }, rest)),
        open && react_1.default.cloneElement(children, { ref: childrenRef })));
};
exports.Popper = Popper;
exports.Popper.displayName = "Popper";
//# sourceMappingURL=Popper.js.map